import { RosterCurrentBalanceFieldEnum as Fields } from 'Common/FieldEnum';

export const rosterReportConfiguration = {
  [Fields.AllStatusesChecked]: true,
  [Fields.Statuses]: [],
  [Fields.AllSitesChecked]: true,
  [Fields.Sites]: [],
  [Fields.ShowBalance]: true,
  [Fields.ShowStatus]: true,
  [Fields.Grade]: 'ALL',
  [Fields.AccountBalanceType]: 0,
  [Fields.Teacher]: 'ALL',
  [Fields.UseCustomBalanceFilter]: false,
  [Fields.SortBy]: 0,
  [Fields.CustomBalanceFilter]: 0,
  [Fields.BalanceAmount]: '0.00',
};



// WEBPACK FOOTER //
// ./src/pages/CloseSchoolYear/helpers/constants.js